export const GENERATING = "generating";
export const WAITING = "waiting";
export const GENERATED = "generated";

export const HEALTH_DATA = "health";
export const SLOW_DATA = "slow";

export const desciption = {
  [GENERATING]: "Generating file",
  [WAITING]: "Waiting",
  [GENERATED]: "Generated"
}